<template>
    <v-container fluid pa-0 dark flat my-5>
        <v-layout justify-center>
            <div>
                <h1 style="text-align: center;">{{ encabezado }}</h1>
                <div style="text-align: center;">
                    <p>{{ mensaje }}</p>
                    <p>{{ mensaje2 }}</p>
                </div>
            </div>
        </v-layout>
    </v-container>
</template>
<script>
    import * as firebase from 'firebase/app'
	import 'firebase/firestore'
	import cryptoJS from 'crypto-js'
	import axios from 'axios'
    import * as moment from 'moment'

    export default {
        name: 'Solicitud',
	    filters: {
            dateFromTimestamp: function(timestamp) {
                let formattedDate = ''
                if (timestamp.seconds) {
                    formattedDate = timestamp.toDate().toLocaleString()
                } else {
                    formattedDate = new Date(timestamp).toLocaleString()
                }
                return formattedDate
            }
	  },
      data() {
          return {
              pedido: {},
              mensaje: '',
              encabezado: '',
              mensaje2: '',
              mensaje3: ''
          }
      },
      methods: {
          toThousandFilter(num) {
                return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, '.'))
            },
          async get_pedido(id,respuesta,tipo,transporte) {
                console.log(tipo)
                let documento = ''
                tipo == 'f' ? documento = 'fletes_dev' : documento = 'pedidos'
                const db = firebase.firestore()
                const here = this
                await db.collection(documento).doc(id).get().then(function(doc) {
                    const datos = doc.data()
                    if (datos !== undefined) {
                            // data === 0 es cancelar, data === 1 es aceptar
                            datos.id = doc.id
                            //verificar si es que antes fue rechazado
                            let rechazos = 0
                            if (datos.rechazados && datos.rechazados.length > 0) {
                                datos.rechazados.forEach(function(rechazo) {
                                    rechazo == transporte ? rechazos++ : rechazos
                                })
                            }
                            if (rechazos === 0) {
                                if (respuesta == 1) {
                                    here.encabezado = 'ACEPTADO'
                                    const fechaSplit = datos.fecha.split('-')
                                    const fecha = fechaSplit[2] + '/' + fechaSplit[1] + '/' + fechaSplit[0]
                                    here.mensaje = 'Hemos registrado el servicio en tu agenda a las ' + datos.hora + ' del día ' + fecha
                                    here.mensaje2 = 'Gracias por confiar en nosotros.'
                                    here.accepted(datos, documento,transporte)
                                } else if ( respuesta == 0){
                                    here.encabezado = 'RECHAZADO'
                                    here.mensaje = 'De acuerdo a sus instrucciones hemos anulado el servicio.'
                                    here.mensaje2 = 'Muchas Gracias'
                                    here.rejected(datos, documento,transporte)
                                }
                            } else {
                                here.encabezado = 'Ya hemos registrado tu preferencia'
                                here.mensaje2 = 'Muchas Gracias'
                            }
                            
                    } else {
                        here.mensaje = 'Pedido Inexistente.'
                    }
                })
                console.log('Respuesta convenio: ' + respuesta)
          },
          async accepted(datos,documento,transporte) {
                moment.locale("es")
                const db = firebase.firestore()
                const data = {
                    checked: true,
                    aceptado: true
                }
                const registro = {
                    registro: 'Aceptado por transportista: ' + datos.transportista.conductor_data.datos.nombres + ' ' + datos.transportista.conductor_data.datos.apellidos,
                    Fecha_Registro: firebase.firestore.Timestamp.fromDate(new Date()),
                    valorBase: datos.valorBase,
                    usuarioSistema: datos.transportista.conductor_data.datos.nombres + ' ' + datos.transportista.conductor_data.datos.apellidos,
                    activo: false
                }
                console.log(documento)
                console.log(datos.id)
                if(documento === 'fletes_dev') {
                    var addRegistro = db.collection(documento).doc(datos.id)
                    await addRegistro.update({
                        registro: firebase.firestore.FieldValue.arrayUnion(registro)
                    })
                }
                
                // cambio en agenda
                await db.collection('vehiculos').doc(transporte).collection('agenda').doc(datos.transportista.agenda).update(data)
        	    // cambio en pedido
                await db.collection(documento).doc(this.$route.query.id).update(data)
                // correo a admin
                const nuevaFecha = new Date()
                const dataEmail = {
                    accepted: true,
                    documento: documento,
                    idPedido: datos.id,
                    cliente: datos.usuario.nombre,
                    email: datos.usuario.email,
                    fecha: moment(nuevaFecha).format('dddd, DD/MM/YY'),
                    hora: moment(nuevaFecha).format('HH:mm'),
                    transportistaNombre: datos.transportista.conductor_data.datos.nombres + ' ' + datos.transportista.conductor_data.datos.apellidos,
                    fechaServicio: this.formatDate(datos.fecha_servicio_obj)
                }
                documento == 'fletes_dev' ? dataEmail.tipo = 'pre-cotizacion' : dataEmail.tipo = 'mudanzas'
                documento == 'fletes_dev' ? dataEmail.numeroServicio = 'F.' + datos.NS.c_day.toString() + '.' + datos.NS.c_general.toString() + '.' + datos.NS.date.toString() : dataEmail.numeroServicio = datos.NS.c_day.toString() + '.' + datos.NS.c_general.toString() + '.' + datos.NS.date.toString()
                console.log(dataEmail)
                const enviaCorreo = firebase.functions().httpsCallable('transportAcceptance')
                await enviaCorreo(dataEmail)
                .then(({ data }) => {
                    console.log('Transaccion', data)
                    console.log('Antes del descuento')
                })
                .catch(httpsError => {
                    console.log('error: ', httpsError)
                })
                
          },
            formatDate(date) {
                let dateFormated = ''
                try {
                    dateFormated = date.toDate().toLocaleString()
                } catch (error) {
                    const seconds = date.seconds
                    dateFormated = new Date(seconds * 1000).toLocaleString()
                }
                return dateFormated
            },
          async rejected(datos,documento,transporte) {
                const db = firebase.firestore()
                // correo a admin
                const fecha = firebase.firestore.Timestamp.fromDate(new Date())
                const nuevaFecha = new Date()
                const dataEmail = {
                    accepted: false,
                    documento: documento,
                    idPedido: datos.id,
                    cliente: datos.usuario.nombre,
                    email: datos.usuario.email,
                    fecha: moment(nuevaFecha).format('dddd, DD/MM/YY'),
                    hora: moment(nuevaFecha).format('HH:mm'),
                    transportistaNombre: datos.transportista.conductor_data.datos.nombres + ' ' + datos.transportista.conductor_data.datos.apellidos
                }
                documento == 'fletes_dev' ? dataEmail.tipo = 'pre-cotizacion' : dataEmail.tipo = 'mudanzas'
                documento == 'fletes_dev' ? dataEmail.numeroServicio = 'F' + datos.NS.c_day.toString() + '.' + datos.NS.c_general.toString() + '.' + datos.NS.date.toString() : dataEmail.numeroServicio = datos.NS.c_day.toString() + '.' + datos.NS.c_general.toString() + '.' + datos.NS.date.toString()
                const enviaCorreo = firebase.functions().httpsCallable('transportAcceptance')
                await enviaCorreo(dataEmail)
                .then(({ data }) => {
                    console.log('Transaccion', data)
                    console.log('Antes del descuento')
                })
                .catch(httpsError => {
                    console.log('error: ', httpsError)
                })
                // borrar agenda
                await db.collection('vehiculos').doc(transporte).collection('agenda').doc(datos.transportista.agenda).delete().then(function(doc){
                    console.log('Agenda eliminada')
                })
                // borrar transportista de pedido
                const eliminaTransportista = db.collection(documento).doc(datos.id)
                let removeTransportista = eliminaTransportista.update({
                    transportista: firebase.firestore.FieldValue.delete()
                })
                // ingresar a pedido el rechazo del transportista
                const data = {
                    checked: true,
                    aceptado: false
                }
                const idTransportista = transporte
                await db.collection(documento).doc(this.$route.query.id).update(data)
                var addRechazo = db.collection(documento).doc(datos.id)
                await addRechazo.update({
                    rechazados: firebase.firestore.FieldValue.arrayUnion(idTransportista)
                })

          },
          async get_pedidoCotizacion(id,respuesta,tipo,transporte) {
                let documento = ''
                tipo == 'f' ? documento = 'fletes_dev' : documento = 'pedidos'
                const db = firebase.firestore()
                const here = this
                await db.collection(documento).doc(id).get().then(function(doc) {
                    const datos = doc.data()
                    if (datos !== undefined && datos.cotizacion) {
                        datos.id = doc.id
                        if (respuesta == 1 && datos.cotizacion.transportista.id === transporte) {
                            here.encabezado = 'ACEPTADA LA COTIZACION'
                            const fechaSplit = datos.cotizacion.fecha.split('-')
                            const fecha = fechaSplit[2] + '/' + fechaSplit[1] + '/' + fechaSplit[0]
                            here.mensaje = 'Hemos registrado la cotización en tu agenda a las ' + datos.cotizacion.hora + ' del día ' + fecha
                            here.mensaje2 = 'Gracias por confiar en nosotros.'
                            here.acceptedCotizacion(datos, documento,transporte, datos.cotizacion.transportista.agenda)
                        } else if ( respuesta == 0 && datos.cotizacion.transportista.id === transporte){
                            here.encabezado = 'RECHAZADO'
                            here.mensaje = 'De acuerdo a sus instrucciones hemos anulado la cotización.'
                            here.mensaje2 = 'Muchas Gracias'
                            here.rejectedCotizacion(datos, documento,transporte,datos.cotizacion.transportista.agenda)
                        }
                    } else {
                        here.mensaje = 'Pedido Inexistente.'
                    }
                })
          },
          async acceptedCotizacion(datos, documento, transporte, agenda) {
                const db = firebase.firestore()
                const data = {
                    checked: true,
                    aceptado: true,
                    onHold: false
                }
                // cambio en agenda
                datos.cotizacion.aceptado = true
                await db.collection('vehiculos').doc(transporte).collection('agenda').doc(agenda).update(data)
                const dataCotizacion = {
                    cotizacion: datos.cotizacion
                }
                await db.collection(documento).doc(this.$route.query.id).update(dataCotizacion)
                if (datos.registroCotizacion.length > 1) {
                    let arregloCotizaciones = datos.registroCotizacion
                    arregloCotizaciones[datos.registroCotizacion.length - 1].aceptado = true
                    const dataUpdateArray = {
                        registroCotizacion: arregloCotizaciones
                    }
                    await db.collection(documento).doc(datos.id).update(dataUpdateArray)
                }
                await db.collection('cotizaciones').doc(datos.cotizacion.id).update(datos.cotizacion)
                // enviar correo
                const nuevaFecha = new Date()
                const dataEmail = {
                    accepted: true,
                    fecha: moment(nuevaFecha).format('dddd, DD/MM/YY'),
                    hora: moment(nuevaFecha).format('HH:mm'),
                    documento: documento,
                    idPedido: datos.id,
                    cliente: datos.usuario.nombre,
                    email: datos.usuario.email,
                    fechaCotizacion: datos.cotizacion.fecha,
                    horaCotizacion: datos.cotizacion.hora,
                    nombreTransporte: datos.cotizacion.transportista.conductor_data.datos.nombres + ' ' + datos.cotizacion.transportista.conductor_data.datos.apellidos,
                }
                documento == 'fletes_dev' ? dataEmail.numeroServicio = 'F' + datos.NS.c_day.toString() + '.' + datos.NS.c_general.toString() + '.' + datos.NS.date.toString() : dataEmail.numeroServicio = datos.NS.c_day.toString() + '.' + datos.NS.c_general.toString() + '.' + datos.NS.date.toString()
                const quotationRequest = firebase.functions().httpsCallable('quotationRequest')
                await quotationRequest(dataEmail)
                .then(({ emailResponse }) => {
                    console.log(emailResponse)
                })
          },
          async rejectedCotizacion(datos, documento, transporte, agenda) {
                const db = firebase.firestore()
                const data = {
                    cotizacion: {}
                }
                let arregloCotizaciones = datos.registroCotizacion
                arregloCotizaciones[datos.registroCotizacion.length - 1].checked = true
                const dataUpdateArray = {
                    registroCotizacion: arregloCotizaciones
                }
                await db.collection(documento).doc(datos.id).update(dataUpdateArray)
                await db.collection('cotizaciones').doc(datos.cotizacion.id).delete()
                await db.collection('vehiculos').doc(transporte).collection('agenda').doc(agenda).delete()
                await db.collection('fletes_dev').doc(datos.id).update(data)
                // enviar correo
                const nuevaFecha = new Date()
                const dataEmail = {
                    accepted: false,
                    fecha: moment(nuevaFecha).format('dddd, DD/MM/YY'),
                    hora: moment(nuevaFecha).format('HH:mm'),
                    documento: documento,
                    idPedido: datos.id,
                    cliente: datos.usuario.nombre,
                    email: datos.usuario.email
                }
                documento == 'fletes_dev' ? dataEmail.numeroServicio = 'F' + datos.NS.c_day.toString() + '.' + datos.NS.c_general.toString() + '.' + datos.NS.date.toString() : dataEmail.numeroServicio = datos.NS.c_day.toString() + '.' + datos.NS.c_general.toString() + '.' + datos.NS.date.toString()
                const quotationRequest = firebase.functions().httpsCallable('quotationRequest')
                await quotationRequest(dataEmail)
                .then(({ emailResponse }) => {
                    console.log(emailResponse)
                })
          }

      },
      mounted() {
            if(this.$route.query.id && this.$route.query.data && this.$route.query.type && this.$route.query.trp && !this.$route.query.cvn){ 
                this.get_pedido(this.$route.query.id, this.$route.query.data, this.$route.query.type, this.$route.query.trp)
            } else if (this.$route.query.id && this.$route.query.data && this.$route.query.type && this.$route.query.trp && this.$route.query.cvn) {
                this.get_pedidoCotizacion(this.$route.query.id, this.$route.query.data, this.$route.query.type, this.$route.query.trp)
            } else {
                console.log('no hay pedido identificado')
            }
      }
    }
</script>